import { z } from 'zod';
/**
 * Guided tours (requests.md R-07): which a person has taken, on the server so
 * it follows them across devices.
 *
 * The TOURS themselves live in the web app (features/tour/tours.ts) - their
 * steps point at screens. The server keeps only what a person did with each:
 * finished it, or skipped it, and when. An id it has never heard of is fine:
 * a new tour ships with the app, and its first mark creates its entry.
 */
export const TOUR_STATUSES = ['done', 'skipped'];
export const markTourSchema = z
    .object({
    status: z.enum(TOUR_STATUSES),
})
    .strict();
/** A tour id: lowercase words and dashes, e.g. "welcome", "vendors-2026-10". */
export const tourIdSchema = z.string().trim().regex(/^[a-z0-9-]{2,60}$/, 'Not a tour');
//# sourceMappingURL=tours.js.map